
import React, {Component} from 'react';
import { IntercomAPI } from 'react-intercom';

import { Switch, Route, Redirect } from 'react-router-dom';
import axios from "axios";
import { faPlusCircle, faTimesCircle, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core'
import PatternViewComponent from "./PatternViewComponent";

import ProductsViewComponents from "./ProductsViewComponents";
import BrandPageViewComponent from "./BrandPage/BrandPageViewComponent";
import InfoProduct from "../../shared/infoProduct/components/infoProductComponent"
import CartViewComponent from './CartViewComponent';
import RegisterViewComponent from './RegisterViewComponent';
import OrderViewComponent from './OrderViewComponent';
import RecoveryViewComponent from './RecoveryViewComponent';
import CreateMyOwnListComponent from "../../shared/createmyownlist/components/CreateMyOnListComponent";
import LandingComponent from "../../landing/views/components/LandingComponent";
import HomeSugestedViewComponent from "./HomeSugestedViewComponent";
import WhoWeAre from "../../whoweare/views/components/WhoWeAre";
import ToTheWorld from "../../totheworld/components/ToTheWorld";
import ConnectedCollaboration from "../../connectedcollaboration/components/ConnectedCollaboration";
import BrandsViewComponent from "./BrandsViewComponent";
import CategoriesViewComponent from "./CategoriesViewComponent";



function PrivateRoute({ component: Component, ...rest }) {

  const params = new URLSearchParams(arguments[0].location.search);
  let pathname = arguments[0].location.pathname
  let next = ""
  let params_string = "";
  for(var key of params.keys()) {
      let value = params.get(key)
      if(key !== "next"){
        params_string += `&${key}=${value}`
      }
  }
  if(pathname && !window.localStorage.getItem("user")){
    next = `?next=${pathname}${params_string}`
  }
  const has_next = params.get('next', null);
  if(has_next){
    next = `?next=${has_next}${params_string}`
  }

  return (
    <Route
      {...rest}
      render={props =>
        window.localStorage.getItem("user") ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              search: next,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

class RouterSwitchComponent extends Component {

    constructor(){
        super();
        library.add(faPlusCircle, faTimesCircle, faEnvelopeOpen);
    }

    componentWillMount(){
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

       axios.interceptors.request.use((request) => {
            let accessToken = localStorage.getItem("access_token");
            if(accessToken) {
                request.headers["Authorization"] = `Bearer ${accessToken}`;
                request.headers["Accept-Language"] = 'en';
                request.headers["Content-Language"] = 'en';
            }
            return request;
        });

        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            if(error.response){
              if (error.response.data.error !== "invalid_grant"){
                if (401 === error.response.status) {
                  window.localStorage.clear();
                  IntercomAPI('shutdown');

                  const params = new URLSearchParams(window.location.search);
                  let pathname = window.location.pathname
                  let params_string = "";
                  let has_next = params.get('next', null)

                  if(pathname && has_next === null){

                    for(var key of params.keys()) {
                        let value = params.get(key)
                        if(key !== "next"){
                          params_string += `&${key}=${value}`
                        }
                    }
                  }
                  window.location.href = `?next=${pathname}${params_string}`

                }
              }
            }
            return Promise.reject(error);
        });
    }

    render() {
        return (
           <div>
                <React.Suspense fallback={null}>
                    <Switch>

                        <Route path="/" exact={true} render={() => (
                          window.localStorage.getItem("user") ? (
                            window.localStorage.getItem("user_type") === "buyer" ? (
                              <Redirect to="/home"/>
                            ):(

                              <Redirect to={`/${window.localStorage.getItem('seller_slug')}`}/>
                            )
                          ) : (
                            <LandingComponent />
                          )
                        )}/>

                        <PrivateRoute path="/newhome" exact={true} component={BrandsViewComponent} />
                        <Route path="/whoweare" exact={true} component={WhoWeAre} />
                        <Route path="/connectedcollaboration" exact={true} component={ConnectedCollaboration} />
                        <Route path="/totheworld" exact={true} component={ToTheWorld} />
                        <PrivateRoute path="/categories" exact={true} component={CategoriesViewComponent} />
                        <PrivateRoute path="/brands" exact={true} component={BrandsViewComponent} />             
                        <PrivateRoute path="/home" exact={true} component={window.localStorage.getItem("user_stype") === "seller" ? HomeSugestedViewComponent :BrandsViewComponent} />
                        <PrivateRoute path="/homes" exact={true} component={HomeSugestedViewComponent} />
                        <PrivateRoute path="/pattern" exact={true} component={PatternViewComponent} />
                        <PrivateRoute path="/products" exact={true} component={ProductsViewComponents} />
                        <PrivateRoute path="/product/:id" exact={true} component={InfoProduct} />
                        <PrivateRoute path="/cart" exact={true} component={CartViewComponent} />
                        <Route path="/register" exact={true} component={RegisterViewComponent} />
                        <Route path="/recovery/:token" exact={true} component={RecoveryViewComponent} />
                        <PrivateRoute path="/order" exact={true} component={OrderViewComponent} />
                        <PrivateRoute path="/order/:id" exact={true} component={OrderViewComponent} />
                        <PrivateRoute path="/createmyownlist/:id" exact={true} component={CreateMyOwnListComponent} />
                        <PrivateRoute path="/:slug" component={BrandPageViewComponent} />
                        {/* <PrivateRoute path="/:slug/history" exact={true} component={BrandHistoryViewComponent} />
                        <PrivateRoute path=":slug/collections" exact={true} component={BrandHistoryViewComponent} />
                        <PrivateRoute path=":slug/collections/:collectionId" exact={true} component={BrandHistoryViewComponent} /> */}
                    </Switch>
                </React.Suspense>
           </div>
       );
    }
}


export default RouterSwitchComponent;
